import { createElement, memo } from '@max/max';
import TopView from '@max/leez-top-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
import { AmountType } from '../../types/rewardRecords';
import CouponItem from './coupon-item';
import LinearGradient from '@hfe/max-linear-gradient';
import Button from '@hfe/max-button';
import Image from '@hfe/max-image';
import './index.scss';
import { useMonitorJumper } from '@nibfe/mcp-monitor-sdk';
function CouponModal(props) {
    const { visible, onClose, rewardItemList, onOpened } = props;
    const { monitorNavigateToSmart } = useMonitorJumper();
    return <TopView>
      <ModalBaseContainer visible={visible} type="fade" onMaskPress={onClose} onOpened={onOpened}>
        <View className="coupon-modal__wrapper">
          <View className="coupon-modal__content-wrapper">
            <Text className="coupon-modal__title-text">优惠券包</Text>
            <View className="coupon-modal__coupon-list-wrapper">
              <ScrollView showsVerticalScrollIndicator={false}>
                <View className="coupon-modal__scroll-content-wrapper">
                  {rewardItemList?.filter(item => item.amountType === AmountType.THRESHOLD)?.map((curRewardItem, index) => <View className="coupon-modal__coupon-item" key={curRewardItem.prizeBatchId}>
                        <CouponItem rewardItem={curRewardItem} onClickItem={rewardItem => monitorNavigateToSmart(rewardItem?.jumpUrl ?? '')}/>
                      </View>)}
                </View>
              </ScrollView>
            </View>
            <LinearGradient className="coupon-modal__bottom-gradient" colors={['#ffffff00', '#ffffffff']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }}/>
            <Text className="coupon-modal__bottom-text">优惠券已入账【酒旅频道-我的优惠】</Text>
          </View>
          <Button className="cfe-five-city-close-button" onPress={() => {
        onClose();
    }}>
            <Image className="cfe-five-city-close-button-img" source={{
        uri: 'https://p0.meituan.net/ingee/dacb6cc62b5d35e0e749fc7a73bbe7821798.png'
    }}/>
          </Button>
        </View>
      </ModalBaseContainer>
    </TopView>;
}
export default memo(CouponModal);
